function Bangladesh({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_608)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#496E2D"/>
        <path d="M12.5218 22.9565C16.3638 22.9565 19.4783 19.8419 19.4783 16C19.4783 12.158 16.3638 9.04346 12.5218 9.04346C8.67984 9.04346 5.56531 12.158 5.56531 16C5.56531 19.8419 8.67984 22.9565 12.5218 22.9565Z" fill="#D80027"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Bangladesh;
